/**
 * API клієнт для doc.currency_purchase_sale (Фаза 2.1 #2).
 */
import { api } from './client';
import type { Page } from './catalogs';
import type { CancellableState } from './cancellation';

export type CurrencyOperationType = 'PURCHASE' | 'SALE';

export interface CurrencyOperation {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  posted: boolean;
  posted_at: string | null;
  deletion_mark: boolean;
  comment: string | null;
  // Block 5.3f:
  state?: CancellableState;
  cancelled_at?: string | null;
  cancellation_reason?: string | null;
  operation_type: CurrencyOperationType;
  from_bank_account_id: string;
  to_bank_account_id: string;
  currency_id: string;
  currency_amount: string;
  commercial_rate: string;
  nbu_rate: string;
  uah_amount_commercial: string;
  uah_amount_nbu: string;
  fx_difference: string;
  bank_commission: string;
  bank_commission_account_id: string | null;
  payment_order_id: string | null;
  related_bank_payment_id: string | null;
  related_bank_receipt_id: string | null;
  external_source?: string | null;
  created_at: string;
  updated_at: string;
}

export interface CurrencyOperationCreate {
  organization_id: string;
  document_number?: string | null;
  document_date: string;
  comment?: string | null;
  operation_type: CurrencyOperationType;
  from_bank_account_id: string;
  to_bank_account_id: string;
  currency_id: string;
  currency_amount: string;
  commercial_rate: string;
  nbu_rate: string;
  bank_commission?: string;
  bank_commission_account_id?: string | null;
  payment_order_id?: string | null;
}

export type CurrencyOperationUpdate = Partial<Omit<CurrencyOperationCreate, 'organization_id'>>;

export const currencyOperations = {
  list: (params?: {
    organization_id?: string;
    operation_type?: CurrencyOperationType;
    limit?: number;
    offset?: number;
  }) => api.get<Page<CurrencyOperation>>('/documents/currency-operations', { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<CurrencyOperation>(`/documents/currency-operations/${id}`).then((r) => r.data),
  create: (payload: CurrencyOperationCreate) =>
    api.post<CurrencyOperation>('/documents/currency-operations', payload).then((r) => r.data),
  update: (id: string, payload: CurrencyOperationUpdate) =>
    api.patch<CurrencyOperation>(`/documents/currency-operations/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/documents/currency-operations/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<CurrencyOperation>(`/documents/currency-operations/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<CurrencyOperation>(`/documents/currency-operations/${id}/unpost`).then((r) => r.data),
  cancel: (id: string, reason: string) =>
    api.post(`/documents/currency-operations/${id}/cancel`, { cancellation_reason: reason }).then((r) => r.data),
};
